import React, {useEffect, useState} from 'react';
import {useTheme} from "../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    createTimeout,
    deepObjectComparison,
    focusFormIdElement,
    getDefStr,
    getJsonValue,
    isBoolTrue,
    isJsonValueTrue,
    sanitizeMobileText
} from "../../common/fusion-ui/utils/ReactUtils";
import {sendAdminRequest} from "../utils/AdminUtils";
import {printError, printLog,} from "../../common/CommonUtils";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";
import {useNavigate} from "react-router-dom";
import {AdminModuleFieldsData, AdminModuleRouteUrls, AdminModules, AdminReqUrls, ShowViewType} from "../config/AdminConfig";
import {Checkbox, Flexbox, GridBox, HorDiv, Label, NullMsgLabel, Select} from "../../common/fusion-ui";
import {CssVariant, IconClass, Messages, Patterns} from "../../common/fusion-ui/config/FusionConfig";
import {ThemedInput} from "../../common/components";
import {FormPageRoot} from "../components";
import {AnimationType, EasingType, FramerAnimator} from "../../common/fusion-ui/animation/FramerAnimator";
import {ThemedIconButton} from "../../app";
import {useInternetStatus} from "../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../common/CommonConfig";

const User__AddEditFormPage = React.memo(({
                                              updateOnly,
                                              open,
                                              onHide,
                                              recordId,
                                              showAs = ShowViewType.PAGE,
                                              onSuccess,
                                          }) => {
    const TAG = "User__AddEditFormPage";

    const moduleName = AdminModules.Users;
    const mf = AdminModuleFieldsData[moduleName];

    const theme = useTheme();
    const navigate = useNavigate();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const animator = new FramerAnimator();

    const FOCUS_DELAY = 2000;
    const Fields = {
        updateRecordId: 'updateRecordId',

        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        companies: 'companies',
        showCompaniesLoading: 'showCompaniesLoading',
        isCompDataFetched: 'isCompDataFetched',

        roles: 'roles',
        showRolesLoading: 'showRolesLoading',
        isRolesDataFetched: 'isRolesDataFetched',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(User__AddEditFormPage_FormData);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        if (!checkNullStr(getField(Fields.panelMsg)) && !isUpdateMode()) {
            updateField(Fields.isDataLoading, false);
            updateField(Fields.isDataFound, true);
        }

        log('useEffect.showAs:', showAs);
        // if (showAs == ShowViewType.PAGE) {
        //     if (isUpdateMode()) {
        //         const id = getCurrUrlParamValue('id');
        //         log('useEffect.showAs:', showAs, 'id:', id);
        //         fetchEditModeData(id);
        //     }
        // } else {
        //     if (checkNullStr(recordId) && (isUpdateMode())) {
        //         fetchEditModeData(recordId, false);
        //     }
        // }
        Promise.all([fetchRoles(false), fetchCompanies(false)]);
    }, [recordId, showAs, updateOnly]);

    return (<>
            <FormPageRoot
                tag={TAG}
                moduleName={moduleName}
                updateOnly={isUpdateMode()}
                isDataLoading={getField(Fields.isDataLoading)}
                isDataFound={getField(Fields.isDataFound)}
                dataLoadingMsg={getField(Fields.dataLoadingMsg)}
                open={open}
                onHide={() => {
                    if (onHide) onHide();
                    clearPanelData(true);
                }}
                animateChildren={false}
                showAs={showAs}
                md={showAs == ShowViewType.PAGE ? 12 : 12}
                panelMsg={getField(Fields.panelMsg)}
                panelMsgColor={getField(Fields.panelMsgColor)}
                isSubmitDisabled={isFieldTrue(Fields.submitBtn_disabled)}
                isSubmitLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                onSubmit={handleSubmit}>
                <div>
                    <GridBox className={'px-2'} sm={12} md={6} justifyAt={'start'}>
                        {/*left-section*/}
                        {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                            <div>
                                {/*role-select*/}
                                <Select
                                    id={mf.roleId.column}
                                    wrapperClassName={`w-100`}
                                    className={`w-100 rounded-3 py-2`}
                                    innerWrapperClassName={'w-100'}
                                    labelClassName={'w-100 text-input-label'}
                                    variant={'primary'}
                                    justifyAt={'center'}
                                    labelColor={theme.text40}
                                    label={mf.roleId.title}
                                    placeholder={'Select a user role'}
                                    wrap={'wrap'}
                                    textKey={'text'}
                                    idKey={'id'}
                                    required={true}
                                    options={getField(Fields.roles, [])}
                                    defOption={getFormField(mf.roleId)}
                                    showLoader={isFieldTrue(Fields.showRolesLoading)}
                                    showRefresh={true}
                                    onRefresh={() => fetchRoles(false)}
                                    onChange={(e, text, value) => {
                                        log('role.Select.onChange::text:', text, "value:", value);
                                        updateFormField(mf.roleId, value);
                                        updateFormField(mf.roleName, text);
                                    }}
                                />

                                {/*username*/}
                                <ThemedInput
                                    wrapperClassName={'mt-3'}
                                    className={''}
                                    label={mf.username.title}
                                    placeholder={mf.username.title}
                                    id={mf.username.column}
                                    value={getFormField(mf.username)}
                                    msg={getFormFieldMsg(mf.username)}
                                    required={true}
                                    validate={true}
                                    pattern={Patterns.simpleText}
                                    type={'text'}
                                    showLimitLabel={true}
                                    maxLength={30}
                                    onChange={(e) => {
                                        const value = (e.target.value + '').toLowerCase().trim();
                                        updateFormField(mf.username, value);
                                        panelLog('');
                                        if (checkNullStr(value)) updateFormFieldMsg(mf.username, '');
                                    }}
                                />

                                {/*passwordV2*/}
                                <ThemedInput
                                    className={''}
                                    label={mf.passwordV2.titleAlt}
                                    placeholder={mf.passwordV2.titleAlt}
                                    id={mf.passwordV2.column}
                                    value={getFormField(mf.passwordV2)}
                                    msg={getFormFieldMsg(mf.passwordV2)}
                                    required={true}
                                    type={'text'}
                                    onChange={(e) => {
                                        const value = e.target.value + '';
                                        updateFormField(mf.passwordV2, value);
                                        panelLog('');
                                        if (checkNullStr(value)) {
                                            updateFormFieldMsg(mf.passwordV2, '');
                                            updateFormFieldMsg(mf.confirmPassword, '');
                                        }
                                    }}
                                />

                                {/*confirmPassword*/}
                                <ThemedInput
                                    className={''}
                                    label={mf.confirmPassword.title}
                                    placeholder={mf.confirmPassword.title}
                                    id={mf.confirmPassword.column}
                                    value={getFormField(mf.confirmPassword)}
                                    msg={getFormFieldMsg(mf.confirmPassword)}
                                    required={true}
                                    type={'text'}
                                    onChange={(e) => {
                                        const value = e.target.value + '';
                                        updateFormField(mf.confirmPassword, value);
                                        panelLog('');
                                        if (checkNullStr(value)) {
                                            updateFormFieldMsg(mf.passwordV2, '');
                                            updateFormFieldMsg(mf.confirmPassword, '');
                                        }
                                    }}
                                />

                                {/*isActive*/}
                                {/*{isUpdateMode() &&*/}
                                {/*    <RadioToggle*/}
                                {/*        radioClassName={'w-auto'}*/}
                                {/*        labelColor={theme.text40}*/}
                                {/*        binary={true}*/}
                                {/*        required={true}*/}
                                {/*        checked={boolToBinary(isFormFieldTrue(mf.status))}*/}
                                {/*        config={{*/}
                                {/*            label: mf.status.titleAlt,*/}
                                {/*            active: "YES", inactive: "NO"*/}
                                {/*        }}*/}
                                {/*        onChange={(e, value) => {*/}
                                {/*            log('status.onChange.value:', value);*/}
                                {/*            updateFormField(mf.status, value);*/}
                                {/*        }}*/}
                                {/*    />}*/}
                            </div>
                        )}

                        {/*right-section*/}
                        {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                            <div>
                                {/*fullName*/}
                                <ThemedInput
                                    className={''}
                                    label={mf.fullName.title}
                                    placeholder={mf.fullName.title}
                                    id={mf.fullName.column}
                                    value={getFormField(mf.fullName)}
                                    msg={getFormFieldMsg(mf.fullName)}
                                    required={true}
                                    type={'text'}
                                    onChange={(e) => {
                                        const value = e.target.value + '';
                                        updateFormField(mf.fullName, value);
                                        panelLog('');
                                        if (checkNullStr(value)) updateFormFieldMsg(mf.fullName, '');
                                    }}
                                />

                                {/*email*/}
                                <ThemedInput
                                    className={''}
                                    label={mf.email.title}
                                    placeholder={mf.email.title}
                                    id={mf.email.column}
                                    value={getFormField(mf.email)}
                                    msg={getFormFieldMsg(mf.email)}
                                    required={true}
                                    type={'email'}
                                    onChange={(e) => {
                                        const value = e.target.value + '';
                                        if (value.length <= 100) {
                                            if (checkNullStr(value)) {
                                                let valid = Patterns.emailStandard.test(value);
                                                updateFormField(mf.email, value);
                                                if (checkNullStr(value)) updateFormFieldMsg(mf.email, valid ? '' : 'Invalid email!');
                                            }
                                        }
                                        panelLog('');
                                    }}
                                />

                                {/*mobile*/}
                                <ThemedInput
                                    className={''}
                                    label={mf.mobile.title}
                                    placeholder={mf.mobile.title}
                                    id={mf.mobile.column}
                                    value={getFormField(mf.mobile)}
                                    msg={getFormFieldMsg(mf.mobile)}
                                    required={true}
                                    type={'mobile'}
                                    onChange={(e) => {
                                        const value = e.target.value + '';
                                        if (value.length <= 14) {
                                            updateFormField(mf.mobile, sanitizeMobileText(value, 14));
                                            if (checkNullStr(value)) updateFormFieldMsg(mf.mobile, '');
                                        }
                                        panelLog('');
                                    }}
                                />

                                {/*remark*/}
                                <ThemedInput
                                    className={''}
                                    label={mf.remark.title}
                                    placeholder={mf.remark.title}
                                    id={mf.remark.column}
                                    value={getFormField(mf.remark)}
                                    msg={getFormFieldMsg(mf.remark)}
                                    asTextArea={true}
                                    style={{height: '50px', minHeight: '30px', maxHeight: '260px'}}
                                    type={'text'}
                                    onChange={(e) => {
                                        const value = e.target.value + '';
                                        updateFormField(mf.remark, value);
                                        panelLog('');
                                        if (checkNullStr(value)) updateFormFieldMsg(mf.remark, '');
                                    }}
                                />
                            </div>
                        )}
                    </GridBox>

                    <HorDiv variant={theme.text70}/>

                    {/*assignCompany*/}
                    {animator.setAnimationType(AnimationType.SLIDE_UP).render(
                        <div className={'px-2 mt-3'}>
                            <Label className={`text-input-label px-2 m-0 p-0 pb-1`} required={true}
                                   color={theme.text40}>
                                {mf.assignCompany.title}
                            </Label>

                            {/*company-cbs*/}
                            <GridBox className={''} sm={12} md={4} gapY={0} justifyAt={'start'}>
                                {(isFieldTrue(Fields.isRolesDataFetched) && checkNullArr(getField(Fields.companies)))
                                    ? getField(Fields.companies).map((item, index) => {
                                        return <div key={index + item.text}
                                                    className={'d-flex w-auto'}>
                                            <Checkbox
                                                wrapperClassName={'w-auto'}
                                                labelColor={theme.text}
                                                py={0}
                                                defaultChecked={checkNullArr(getFormField(mf.assignCompany)) && getFormField(mf.assignCompany).includes(item.id)}
                                                checked={checkNullArr(getFormField(mf.assignCompany)) && getFormField(mf.assignCompany).includes(item.id)}
                                                onChange={(e, value) => {
                                                    const fun = 'companies.map.cb.onChange:';
                                                    const itemId = item.id;
                                                    const itemText = item.text;
                                                    try {
                                                        let comps = getFormField(mf.assignCompany);
                                                        comps = checkNullArr(comps) ? comps : [];

                                                        if (comps.includes(itemId)) {
                                                            comps = comps.filter(id => id != itemId);
                                                        } else {
                                                            comps.push(itemId);
                                                        }
                                                        // log(fun, 'itemText:', itemText, 'itemText:', itemText, 'value:', value, '\ncomps:', comps);
                                                        updateFormField(mf.assignCompany, comps);
                                                    } catch (error) {
                                                        logErr(fun, error);
                                                        toast("Selection failed, please try again!", CssVariant.warning);
                                                    }
                                                }}>
                                                {item.text}
                                            </Checkbox>
                                        </div>
                                    })
                                    : ((!isFieldTrue(Fields.isRolesDataFetched)
                                            || (isFieldTrue(Fields.isRolesDataFetched) && !checkNullArr(getField(Fields.companies)))) &&
                                        <Flexbox alignAt={'center'} justifyAt={'start'}>
                                            {/*msg*/}
                                            <NullMsgLabel className={'mt-n2x'}
                                                          textAt={'start'} color={theme.text80}>
                                                {"No companies available!"}
                                            </NullMsgLabel>

                                            {/*refresh-btn*/}
                                            <ThemedIconButton
                                                className={'fs-md'}
                                                tooltip={'Refresh Companies'}
                                                mx={3}
                                                // color={theme.primaryBlue}
                                                // bgColor={theme.textWhite}
                                                // hoverBgColor={theme.primaryBlue}
                                                // borderColor={theme.primaryBlue}
                                                outlined={true}
                                                borderWidth={0}
                                                icon={IconClass.refresh}
                                                // iconSize={'11px'}
                                                size={'26px'}
                                                onClick={() => fetchCompanies(false)}
                                            />
                                        </Flexbox>)}
                            </GridBox>
                        </div>
                    )}
                </div>
            </FormPageRoot>
        </>
    )

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);
                panelLog(null);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.updateRecordId),
                    formData: formData,
                };
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__users_addEditPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                                redirectPage();
                            } else {
                                createTimeout(() => {
                                    clearPanelData(true);
                                }, 300);
                            }
                            if (onSuccess) onSuccess();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchRoles(checkBefore = true) {
        const fun = 'fetchRoles:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isRolesDataFetched))) {
            updateField(Fields.isRolesDataFetched, true);
            updateField(Fields.showRolesLoading, true);
            updateField(Fields.roles, []);
            updateFormField(mf.roleId, null);
            updateFormField(mf.roleName, null);
            try {
                //send-request
                const REQUEST_OPTIONS = {};
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__userRoles__mainPage_fetch_recordList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);
                        let list = getJsonValue(fetchedData, 'data', []);
                        const success = checkNullArr(list);
                        if (success) {
                            //format list
                            const mf_Roles = AdminModuleFieldsData[AdminModules.UserRoles];
                            list = list.map((item) => {
                                return {
                                    id: getJsonValue(item, mf_Roles.recordId.title),
                                    text: getJsonValue(item, mf_Roles.name.title),
                                };
                            }).filter(item => checkNullJson(item));
                            log(fun, 'fetchedData.list:', list);

                            updateField(Fields.roles, list);
                        } else {
                            toast("No roles found!", CssVariant.danger);
                        }
                        updateField(Fields.showRolesLoading, false);
                    }),
                    onError: ((error) => {
                        toast("Couldn't load roles, please try again!", CssVariant.danger);
                        updateField(Fields.showRolesLoading, false);
                        logErr(fun, error);
                    }),
                });
            } catch (error) {
                toast("Couldn't load roles, please try again!", CssVariant.danger);
                updateField(Fields.showRolesLoading, false);
                logErr(fun, error);
            }
        }
    }

    async function fetchCompanies(checkBefore = true) {
        const fun = 'fetchCompanies:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isCompDataFetched))) {
            updateField(Fields.isCompDataFetched, true);
            updateField(Fields.showCompaniesLoading, true);
            updateField(Fields.companies, []);
            try {
                //send-request
                const REQUEST_OPTIONS = {};
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__company__mainPage_fetch_recordList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);
                        let list = getJsonValue(fetchedData, 'data', []);
                        const success = checkNullArr(list);
                        if (success) {
                            //format list
                            const mf_comp = AdminModuleFieldsData[AdminModules.Company];
                            list = list.map((item) => {
                                return {
                                    id: getJsonValue(item, mf_comp.recordId.title),
                                    text: getJsonValue(item, mf_comp.companyName.title),
                                };
                            }).filter(item => checkNullJson(item));
                            log(fun, 'fetchedData.list:', list);

                            updateField(Fields.companies, list);
                        } else {
                            toast("No companies found!", CssVariant.danger);
                        }
                        updateField(Fields.showCompaniesLoading, false);
                    }),
                    onError: ((error) => {
                        toast("Couldn't load companies, please try again!", CssVariant.danger);
                        updateField(Fields.showCompaniesLoading, false);
                        logErr(fun, error);
                    }),
                });
            } catch (error) {
                toast("Couldn't load companies, please try again!", CssVariant.danger);
                updateField(Fields.showCompaniesLoading, false);
                logErr(fun, error);
            }
        }
    }

    async function fetchEditModeData(recordId, checkBefore = true) {
        const fun = 'fetchEditModeData:';
        try {
            log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));
            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isUpdateFormDataFetched))) {
                updateField(Fields.isUpdateFormDataFetched, true);
                updateField(Fields.updateRecordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");
                    setFormData({});
                    setFormFieldsMsgs({});

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                    };
                    sendAdminRequest({
                        reqUrl: AdminReqUrls.admin__users_fetchEditPageRecord,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: (async (fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedFormData = getJsonValue(fetchedData, 'data', {});
                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                setFormData(fetchedFormData);
                            } else {
                                toast(message, CssVariant.danger);
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                // window.location.href = AdminModuleRouteUrls[moduleName];
                navigate(AdminModuleRouteUrls[moduleName]);
            }, 2500);
        }, 500);
    }

    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [mf.roleId, mf.username, mf.passwordV2, mf.confirmPassword, mf.fullName, mf.email, mf.mobile, mf.assignCompany];

        let verified = false;
        let colField = {};
        for (const loopField of requiredFields) {
            const fieldValue = formData[loopField.column];
            if (!checkNullStr(fieldValue)) {
                colField = loopField;
                verified = false;
                break;
            } else if (checkNullStr(getFormField(mf.passwordV2)) && checkNullStr(getFormField(mf.confirmPassword)) && (deepObjectComparison(loopField, mf.passwordV2) || deepObjectComparison(loopField, mf.confirmPassword))) {
                // log(fun, "colField.passwordV2||confirmPassword.fieldValue:", fieldValue, 'confirmPassword:', getFormField(mf.confirmPassword));
                if (fieldValue != getFormField(mf.confirmPassword)) {
                    toast("Password don't match!", CssVariant.danger);
                    updateFormFieldMsg(mf.confirmPassword, "Password don't match!");
                    focusIdField(mf.confirmPassword.column);
                    return false;
                } else {
                    verified = true;
                }
            } else if (checkNullStr(getFormField(mf.email)) && deepObjectComparison(loopField, mf.email)) {
                let valid = Patterns.emailStandard.test(fieldValue);
                // log(fun, "email-validation-condition:", colField, 'fieldValue:', fieldValue, 'valid:', valid);
                if (!valid) {
                    verified = false;
                    const colTitle = getDefStr(loopField.titleAlt, loopField.title);
                    toast(`'${colTitle}' is invalid!`, CssVariant.danger);
                    updateFormFieldMsg(loopField, 'Invalid email!');
                    focusIdField(loopField.column);
                    return false;
                } else {
                    verified = true;
                }
            } else {
                verified = true;
            }
        }
        if (!verified) {
            const colTitle = getDefStr(colField.titleAlt, colField.title);
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colTitle}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }


    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }


    function clearPanelData(refetchAddFormData = false) {
        const recyclableData = isBoolTrue(refetchAddFormData) ? {
            [Fields.companies]: getField(Fields.companies),
            [Fields.showCompaniesLoading]: getField(Fields.showCompaniesLoading),
            [Fields.isCompDataFetched]: getField(Fields.isCompDataFetched),

            [Fields.roles]: getField(Fields.roles),
            [Fields.showRolesLoading]: getField(Fields.showRolesLoading),
            [Fields.isRolesDataFetched]: getField(Fields.isRolesDataFetched),
        } : {};

        setFormFieldsMsgs({});
        setFormData({});
        setFieldsData({});

        log('clearPanelData.refetchAddFormData:', refetchAddFormData, 'recyclableData:', recyclableData);
        if (isBoolTrue(refetchAddFormData) && showAs != ShowViewType.PAGE && !isUpdateMode()) {
            updateField(Fields.dataLoadingMsg, '');
            updateField(Fields.isDataFound, true);
            updateField(Fields.isDataLoading, false);

            // Promise.all([fetchRoles(false), fetchCompanies(false)]);
            setFieldsData({...recyclableData});
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        if (text) log(...[text]);
        ;
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        if (text) log(...[text]);
        ;
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

//======================Util Functions end=====================
});
export default User__AddEditFormPage;
